"use client"

import { useSupportChatSettings } from "@/hooks/use-show-intercom"

import { DocsLauncher } from "./docs-launcher"
import { IntercomLauncher } from "./intercom-launcher"

export function ChatLauncher() {
  const { redirectToDocs } = useSupportChatSettings()

  if (redirectToDocs) return <DocsLauncher />

  return <IntercomLauncher />
}
